import React from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import SelectionInput from '../../common/SelectionInput';

const HeroSectionModal = ({
  heroType,
  setHeroType,
  surveySearch,
  articleSearch,
  selectedSurvey,
  selectedArticles,
  activeSurveyDropdown,
  activeArticleDropdown,
  surveyList,
  handleSurveySearch,
  handleArticleSearch,
  handleSurveySelect,
  handleArticleSelect,
  selectedItem,
  heroIndex,
  setHeroIndex,
  handleHeroSectionSubmit,
  clearSelections
}) => {
  return (
    <div className="p-4">
      <h5 className="text-primary mb-3">Edit Hero Section</h5>

      <div className="mb-3">
        <label htmlFor="heroType" className="form-label">
          Type
        </label>
        <select
          id="heroType"
          className="form-select"
          value={heroType}
          onChange={(e) => {
            setHeroType(e.target.value);
            clearSelections();
          }}
        >
          <option value="">Please select the type</option>
          <option value="survey">Survey</option>
          <option value="article">Article</option>
        </select>
      </div>

      {heroType === "survey" && (
        <SelectionInput
          label="Please select the survey"
          placeholder="Search Survey"
          value={surveySearch}
          onSearch={handleSurveySearch}
          onSelect={handleSurveySelect}
          onClear={clearSelections}
          results={surveyList.surveys}
          isActive={activeSurveyDropdown}
          onFocus={() => handleSurveySearch(surveySearch)}
        />
      )}

      {heroType === "article" && (
        <SelectionInput
          label="Please select the article"
          placeholder="Search Article"
          value={articleSearch}
          onSearch={handleArticleSearch}
          onSelect={handleArticleSelect}
          onClear={clearSelections}
          results={surveyList.articles}
          isActive={activeArticleDropdown}
          onFocus={() => handleArticleSearch(articleSearch)}
        />
      )}

      <div className="mb-3">
        <label htmlFor="heroIndex" className="form-label">
          Index
        </label>
        <input
          type="number"
          id="heroIndex"
          className="form-control"
          value={selectedItem?.index || heroIndex}
          onChange={(e) => setHeroIndex(e.target.value)}
          placeholder="Enter index number"
          min="1"
          max="4"
          disabled
        />
      </div>

      <Button
        color="primary"
        onClick={handleHeroSectionSubmit}
        disabled={
          !(
            (
              (heroType === "survey" && selectedSurvey) ||
              (heroType === "article" && selectedArticles) ||
              !heroIndex ||
              heroIndex > 4
            )
          )
        }
      >
        Update Hero Section
      </Button>
    </div>
  );
};

export default HeroSectionModal; 